/** An experiment as a column heading or chip: its colour swatch, name and "ref" marker. */

import type { ExperimentSummary } from "@/features/experiments/types";
import type { Tone } from "./metrics";
import { colourOf } from "./selection";

export function Swatch({ index }: { index: number }) {
  return (
    <span aria-hidden className="size-2.5 shrink-0 rounded-[3px]" style={{ background: colourOf(index) }} />
  );
}

export function SeriesLabel({
  experiment,
  index,
  isRef,
}: {
  experiment: ExperimentSummary;
  index: number;
  isRef: boolean;
}) {
  return (
    <span className="inline-flex max-w-[180px] items-center gap-1.5" title={experiment.name}>
      <Swatch index={index} />
      <span className="truncate">{experiment.name}</span>
      {isRef && <span className="shrink-0 font-medium text-muted">· ref</span>}
    </span>
  );
}

export const TONE_CLASS: Record<Tone, string> = {
  better: "text-better",
  worse: "text-worse",
  same: "text-faint",
};
